import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, NgModule } from '@angular/core';
import { DeviceOrientationEnum, FilesService, PlatformService, ScreenService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { TranslateModule } from '@ngx-translate/core';
import {
  CSchool,
  EUserServiceType,
  PackageEnum,
  ServiceContractTerms20230418,
  User,
  UserService,
  UserServiceContract,
} from 'lingo2-models';
import { IAbsoluteEvent } from 'lingo2-models/dist/account';
import { first } from 'lodash';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OnUiCoverModule, OnUiPopoverModule } from 'onclass-ui';
import { OnUiCover } from 'onclass-ui/lib/modules/on-ui-cover/on-ui-cover.component';

@Component({
  selector: 'app-user-service-contract-footer-details',
  templateUrl: './user-service-contract-footer-details.component.html',
  styleUrls: ['../../styles/footer-details.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserServiceContractFooterDetailsComponent extends ChangableComponent {
  @Input()
  public school: CSchool;

  @Input()
  public teacher: User;

  @Input()
  public userServiceContract: UserServiceContract;

  public constructor(
    private screenService: ScreenService,
    public deviceService: DeviceDetectorService,
    protected readonly cdr: ChangeDetectorRef,
    protected readonly platform: PlatformService,
  ) {
    super(cdr, platform);
  }

  public screenClasses() {
    const isPortrait = this.screenService.deviceOrientation === DeviceOrientationEnum.portrait;
    return {
      tablet: this.deviceService.isTablet(),
      mobile: this.deviceService.isMobile(),
      desktop: (!this.deviceService.isTablet() && !this.deviceService.isMobile()) || this.deviceService.isDesktop(),
      portrait: !this.deviceService.isDesktop() && isPortrait,
      landscape: !this.deviceService.isDesktop() && !isPortrait,
    };
  }

  public get userService(): UserService {
    return this.userServiceContract?.user_service;
  }

  public get isSingle() {
    return this.userService?.type === EUserServiceType.single;
  }

  public get isRegular() {
    return this.userService?.type === EUserServiceType.regular;
  }

  public get isCourse() {
    return [EUserServiceType.mini, EUserServiceType.course].includes(this.userService?.type);
  }

  public get cover(): OnUiCover {
    return {
      // img: this.assetsUrl(this.user_service?.cover?.md?.url),
      img: FilesService.getFileUrlBySize(this.userService?.cover_id) || this.assetsUrl('/assets/onclass-logo.svg'),
      title: this.title,
    };
  }

  public get title() {
    return this.userService?.title;
  }

  public get subjectName() {
    return this.userService?.subject?.title;
  }

  public get levelName(): string {
    const level = this.userService?.level?.code;
    return level ? 'subject-levels.' + level : null;
  }

  public get typeName(): string {
    const type = this.userService?.type;
    return type ? `library.user-service-card.type.${EUserServiceType[type]}` : null;
  }

  public get events(): IAbsoluteEvent[] {
    const terms = this.userServiceContract.user_service_terms;

    switch (terms.package) {
      case PackageEnum.ServiceContractTerms20230418Package: {
        const _terms = terms;

        return _terms.schedule.events;
      }

      default:
        return [];
    }
  }

  public get firstEvent(): IAbsoluteEvent {
    return first(this.events);
  }

  public get firstEventDate(): Date {
    return this.firstEvent?.begin_at;
  }

  public trackByFn(index) {
    return index;
  }

  // public get isSeries() {
  //   return this.time?.length > 1;
  // }
}

@NgModule({
  declarations: [UserServiceContractFooterDetailsComponent],
  imports: [CommonModule, OnUiCoverModule, TranslateModule, OnUiPopoverModule],
  exports: [UserServiceContractFooterDetailsComponent],
})
export class UserServiceContractFooterDetailsModule {}
